import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '@/features/billing/PricingPage';

export const Route = createFileRoute('/pricing')({
  component: PricingPage,
});
